import React from 'react';
import { RadioGroup } from 'rsuite';
import { InfoRadio } from '../../../../../components/InfoRadio';
import type { TipoArredondamento } from '../../../../../@types/IPA/PrecoPsicologico';

const OPCOES: { valor: TipoArredondamento; label: string }[] = [
  { valor: 'MAIS_PROXIMO',    label: 'Arredondar pelo valor mais próximo, ou para cima' },
  { valor: 'SEMPRE_PARA_CIMA',  label: 'Arredondar sempre para cima' },
  { valor: 'SEMPRE_PARA_BAIXO', label: 'Arredondar sempre para baixo' },
];

interface Props {
  value: TipoArredondamento;
  onChange: (opcao: TipoArredondamento) => void;
  disabled?: boolean;
  error?: string;
}

export function OpcoesArredondamento({ value, onChange, disabled, error }: Props) {
  return (
    <div className="opc-arred">
      <div className="opc-arred__caixa">
        <RadioGroup
          name="opcaoArredondamento"
          value={value}
          onChange={v => onChange(v as TipoArredondamento)}
        >
          {OPCOES.map(op => (
            <InfoRadio key={op.valor} value={op.valor} disabled={disabled}>
              {op.label}
            </InfoRadio>
          ))}
        </RadioGroup>
      </div>
      {error && <span className="opc-arred__erro">{error}</span>}
    </div>
  );
}
